import { fetchApi } from 'api/fetchApi'
import { paths } from 'api/generated/user_cards'

type Method = paths['/user-cards/this-is-me']['get']
export type Result = Method['responses']['200']['schema']

export const fetchCurrentProfileAuthorizedSharingInfoApi = () =>
  fetchApi<Result>('/user-cards/this-is-me')
